var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatersupply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D420C2",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_12825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7842 16.072H13.9272V21.7868H11.7842V16.072ZM20.3564 10C19.4301 10 18.6339 10.5991 18.3362 11.4287H15.3559C14.9616 11.4287 14.6416 11.7487 14.6416 12.1431C14.6416 12.5374 14.9616 12.8574 15.3559 12.8574H18.3362C18.5539 13.4622 19.0358 13.9456 19.6421 14.1633V16.072H15.3559V15.3577C15.3559 14.9633 15.0359 14.6433 14.6416 14.6433H11.0698C10.6755 14.6414 10.3555 14.9614 10.3555 15.3577V22.5031C10.3555 22.8974 10.6755 23.2174 11.0698 23.2174H14.6416C15.0359 23.2174 15.3559 22.8974 15.3559 22.5031V21.7868H22.4995C23.2977 21.7868 23.9282 22.4193 23.9282 23.2174V25.7158C23.9282 26.1101 24.2482 26.4301 24.6425 26.4301H28.9268C29.3211 26.4301 29.6411 26.1101 29.6411 25.7158V23.2174C29.6411 19.2809 26.436 16.072 22.4995 16.072H21.0708V14.1633C21.6756 13.9456 22.159 13.4622 22.3747 12.8574H25.3569C25.7512 12.8574 26.0712 12.5374 26.0712 12.1431C26.0732 11.7487 25.7531 11.4287 25.3569 11.4287H22.3747C22.0771 10.5991 21.2808 10 20.3564 10Z",
    fill: "#D420C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.644 27.1445C24.2497 27.1445 23.9297 27.4646 23.9297 27.8608V29.2857C23.9297 29.68 24.2497 30 24.644 30C25.0384 30 25.3584 29.68 25.3584 29.2857V27.8608C25.3584 27.4646 25.0384 27.1445 24.644 27.1445Z",
    fill: "#D420C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9293 27.1445C28.5369 27.1464 28.2188 27.4665 28.2188 27.8608V29.2857C28.2188 29.68 28.5369 30 28.9293 30C29.3255 30 29.6456 29.68 29.6436 29.2857V27.8608C29.6456 27.4646 29.3255 27.1445 28.9293 27.1445Z",
    fill: "#D420C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7886 27.1445C26.3942 27.1445 26.0742 27.4646 26.0742 27.8608V29.2857C26.0742 29.68 26.3942 30 26.7886 30C27.1848 30 27.5048 29.68 27.5048 29.2857V27.8608C27.5048 27.4646 27.1848 27.1445 26.7886 27.1445Z",
    fill: "#D420C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_12825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatersupply);
export default __webpack_public_path__ + "static/media/watersupply.d62ccfa99813ea89a39f43e9cea67ab3.svg";
export { ForwardRef as ReactComponent };